import { PermissionValues } from '@gripp/shared-logic';
import { alertPaths } from './alertPaths';
import { AlertsManagement } from './components/alertsManagement';
import { AlertsManagementToolbar } from './components/alertsManagementToolbar';

export const alertsRoutes = [
  {
    path: alertPaths.management,
    element: <AlertsManagement />,
    handle: {
      header: {
        titleKey: 'alertsManagement.menu.title',
        icon: 'bell-alert',
      },
      requiredPermission: PermissionValues.globalAdmin,
      toolbar: <AlertsManagementToolbar />,
    },
  },
];
